var EmailSubscription = (function () {
  

  var $emailSubscription;
  var $emailSubscriptionForm;
  var $serverMessage;
  var $successContainer;
  var $primaryButton;
  var $formsContainer;
  var $optionsToReceive;
  var $selectOptionLabel;
  var $overlay;

  function createDataJson(form) {
    var $formInputs = $(form).find('input');
    var dataJson = {};
    var interests = [];

    Object.keys($formInputs).forEach(function (key) {
      if ($formInputs[key].type === 'checkbox') {
        if ($formInputs[key].checked && $formInputs[key].name !== 'TermsAgree') {
          interests.push($formInputs[key].name);
        }
      } else if ($formInputs[key].value) {
        dataJson[$formInputs[key].name] = $formInputs[key].value;
      }
    });

    dataJson.interests = interests;
    dataJson.configurationItem = $emailSubscription.find('.js-configuration-item').text();

    return dataJson;
  }

  function sendData(form) {
    var action = $(form).attr('action');
    var data = createDataJson(form);

    $.ajax({
      beforeSend: function () {
        showSpinnerOverlay();
      },
      data: JSON.stringify(data),
      method: 'POST',
      contentType: 'application/json; charset=utf-8',
      error: function (jqXHR, textStatus, errorThrown) {
        console.log('error', jqXHR, textStatus, errorThrown);
        showServerMessage(jqXHR.responseJSON);
      },
      success: function (data) {
        showServerMessage(data);
        var $submitSection = $('.js-email-subscription');
        var stringObject = $submitSection.attr('data-tracking-script') ? $submitSection.attr('data-tracking-script') : '';
        var loadObject = JSON.parse(stringObject.split("'").join('"'));
        if (loadObject && Acr.TrackingManager) {
          Acr.TrackingManager.pageLoad(loadObject);
        }

      },
      url: action,
    });
  }

  function showSpinnerOverlay() {
    // Disable scrolling.
    document.addEventListener('touchmove', handleTouchLock, { passive: false });
    $('body').css('overflow', 'hidden');
    $overlay.removeClass('hidden');
  }

  function hideSpinnerOverlay() {
    // Enable scrolling.
    document.removeEventListener('touchmove', handleTouchLock);
    $('body').css('overflow', 'auto');
    $overlay.addClass('hidden');
  }

  function showServerMessage(data) {
    if (data) {
      data = $.parseJSON(data);
    }

    hideSpinnerOverlay();
    if (data.successMsg) {
      if ($primaryButton.length > 0 && data.primaryCtaParameters) {
        $primaryButton.attr('href', $primaryButton.attr('href').concat(data.primaryCtaParameters));
      }
      $serverMessage.html(data.successMsg);
      $formsContainer.addClass('hidden');
      $serverMessage.removeClass('message--error');
      $serverMessage.removeClass('hidden');
      $successContainer.removeClass('hidden');
    } else {
      $serverMessage.addClass('message--error');
      $serverMessage.html(data.errorMsg);
      $serverMessage.removeClass('hidden');
    }
    window.scrollTo(0, 0);
  }

  function handleTouchLock(e) {
    e.preventDefault();
  }

  // This function checks if at least one checkbox is selected
  function checkOptions() {
    if ($optionsToReceive.find('input:checked').length > 0) {
      $selectOptionLabel.addClass('hidden');
      return true;
    }
    $selectOptionLabel.removeClass('hidden');
    $optionsToReceive[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
    return false;

  }

  function onSubmit(e) {
    var validForm = Validation.validateForm(e);
    var optionsChecked = checkOptions();

    if (validForm && optionsChecked) {
      sendData(e.target);
    }
    // Scroll to the section with empty information
    if (!validForm) {
      window.scrollTo(0, 0);
    }

    e.preventDefault();
    return false;
  }

  function attachEvents() {
    // Call the method to send the preferences list form data
    $emailSubscriptionForm.submit(function (event) {
      onSubmit(event);
    });

    // Call events when new email input changes
    $emailSubscriptionForm.find('input')
      .on('keypress', Validation.onKeypress)
      .on('keyup', Validation.onKeyup)
      .on('focus', Validation.onFocus)
      .on('blur', Validation.onBlur);
  }

  function getQuerySelectors() {
    $emailSubscription = $('.js-email-subscription');
    $emailSubscriptionForm = $emailSubscription.find('.js-sign-up-emails-form');
    $optionsToReceive = $emailSubscription.find('.js-options-to-receive');
    $selectOptionLabel = $emailSubscription.find('.js-select-option-label');
    $serverMessage = $emailSubscription.find('.js-server-message');
    $successContainer = $emailSubscription.find('.js-success-container');
    $primaryButton = $emailSubscription.find('.js-primary-button');
    $formsContainer = $emailSubscription.find('.js-form-container');
    $overlay = $emailSubscription.find('.js-overlay');
  }

  function init() {
    getQuerySelectors();
    if ($emailSubscription.length > 0) {
      attachEvents();
    }
  }

  return {
    init: init,
  };
}());
